import { render, staticRenderFns } from "./ActionButtonsRestaurant.vue?vue&type=template&id=9a6e7e88&scoped=true&"
import script from "./ActionButtonsRestaurant.vue?vue&type=script&lang=js&"
export * from "./ActionButtonsRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./ActionButtonsRestaurant.vue?vue&type=style&index=0&id=9a6e7e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6e7e88",
  null
  
)

export default component.exports